<!--
 * @Author: cmchiu
 * @Date: 2023-05-02 10:18:48
 * @LastEditTime: 2023-05-05 12:16:26
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\views\download.vue
 * 
-->
<template>
    <div class="form-download">
        <breadcrumb />

        <div class="layer-container">
            <h2 class="page-title">法規表單</h2>

            <download-ls title="法規資訊" menu-id="0610" />

            <download-ls title="表單下載" menu-id="0620" />
        </div>
    </div>
</template>

<script>
import { goAnchor, GetQueryString } from '@/utils/common'
import { breadcrumb } from '@c'
import { DownloadLs } from './components'

export default {
    name: 'formDownload',

    components: { breadcrumb, DownloadLs },

    data() {
        return {
            configs: {
                loading: false,
            },
            MenuID: this.$route.query.id,
        }
    },

    created() {},

    mounted() {
        this.handleAnchor()
    },

    methods: {
        goAnchor,

        GetQueryString,

        handleAnchor(id) {
            const maodian = !id ? this.MenuID : id //this.GetQueryString('id') //进入页面，如果带有锚点参数，则跳转至锚点地方，参数值就是id名
            if (maodian) {
                this.goAnchor('#m' + maodian)
            }
        },
    },
}
</script>

<style scoped lang="scss">
.anchor__item {
    cursor: pointer;
}
</style>
